export default __webpack_public_path__ + "static/media/mov.ab88cfa8.svg";